<template>
  <div class="col px-0 px-md-3">
    <ColorPointsHeader :message="pinkHeaderMessage" color="rgba(227, 13, 104, 0.5)" />
    <h1 class="row center justify-content-center text-secondary font-weight-bold pb-5">Vous vendez / Vous achetez</h1>
    <div class="col-md-8 offset-md-2 d-flex flex-column align-items-center">
      <div class="col-12 text-center">{{ focus.paragraphe1 ? focus.paragraphe1.texte : '' }}</div>
      <img :src="focus.paragraphe1 ? focus.paragraphe1.image : ''" alt="graphique vente d'un bien" class="img-cover mw-100 lozad m-5">
    </div>
    <div class="row center">
      <h2 class="col-12 text-secondary text-center pt-5">{{ focus.paragraphe2 ? focus.paragraphe2.titre : '' }}</h2>
    </div>
    <div class="text-center font-weight-bold m-5" v-if="formSent" v-html="focus.paragraphe4 ? focus.paragraphe4.texte : 'Le formulaire a bien été envoyé.'"></div>
    <div v-else id="saisieBien"
         class="center py-5 px-2">
      <b-form @submit.stop.prevent="checkErrors"
              class="row w-100 m-0">
        <div class="col-6 col-sm-4 col-md-3 p-2 p-lg-3">
          <div class="champs h-100">
            <span class="text-secondary required">Civilité</span>
            <el-select
              v-if="display"
              v-model="fiche.civilite"
              placeholder="Civilité"
              class="d-inline-block mb-2 mb-lg-0"
              id="civilite"
              name="civilite">
              <el-option
                v-for="(item, idx) in civilitesOptions"
                :key="idx"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <b-form-invalid-feedback :state="error.civilite">{{ errorMessage }}
            </b-form-invalid-feedback>
          </div>
        </div>
        <div class="col-6 col-sm-4 col-md-3 p-2 p-lg-3">
          <div class="champs h-100">
            <b-form-group id="nomGroup"
                          class="d-flex flex-column justify-content-between h-100 m-0"
                          label="Nom"
                          label-for="nom"
                          label-class="required text-secondary"
                          :invalid-feedback="errorMessage"
                          :state="error.nom">
              <b-form-input id="nom"
                            name="nom"
                            placeholder="Votre nom"
                            v-model="fiche.nom"
                            :state="error.nom"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="col-6 col-sm-4 col-md-3 p-2 p-lg-3">
          <div class="champs h-100">
            <b-form-group id="prenomGroup"
                          class="d-flex flex-column justify-content-between h-100 m-0"
                          label="Prénom"
                          label-for="prenom"
                          label-class="required text-secondary"
                          :invalid-feedback="errorMessage"
                          :state="error.prenom">
              <b-form-input id="prenom"
                            name="prenom"
                            placeholder="Votre prénom"
                            v-model="fiche.prenom"
                            :state="error.prenom"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="col-6 col-sm-4 col-md-3 p-2 p-lg-3">
          <div class="champs h-100">
            <b-form-group id="emailGroup"
                              class="d-flex flex-column justify-content-between h-100 m-0"
                              label="Email"
                              label-for="email"
                              label-class="required text-secondary"
                              :invalid-feedback="errorMessage"
                              :state="error.email">
                  <b-form-input id="email"
                                name="email"
                                placeholder="Votre email"
                                v-model="fiche.email"
                                :state="error.email"
                                type="email"></b-form-input>
                </b-form-group>
          </div>
        </div>
        <div class="col-6 col-sm-4 col-md-3 p-2 p-lg-3">
          <div class="champs h-100">
            <b-form-group id="telephoneGroup"
                          class="d-flex flex-column justify-content-between h-100 m-0"
                          label="Téléphone"
                          label-for="telephone"
                          label-class="text-secondary"
                          :invalid-feedback="errorMessage"
                          :state="error.telephone">
              <b-form-input id="telephone"
                            name="telephone"
                            type="tel"
                            pattern="^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$"
                            placeholder="Votre numéro"
                            v-model="fiche.telephone"
                            :state="error.telephone"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="col-6 col-sm-4 col-md-3 p-2 p-lg-3">
          <div class="champs h-100">
            <span class="text-secondary required">Type du bien</span>
            <el-select
              v-if="display"
              v-model="fiche.type"
              placeholder="Type de bien"
              class="d-inline-block mb-2 mb-lg-0"
              id="type"
              name="type">
              <el-option
                v-for="(item, idx) in typeBienOptions"
                :key="idx"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <b-form-invalid-feedback :state="error.type">{{ errorMessage }}
            </b-form-invalid-feedback>
          </div>
        </div>
        <div class="col-6 col-sm-4 col-md-3 p-2 p-lg-3">
          <div class="champs h-100">
            <span class="text-secondary required">Secteur du bien</span>
            <el-select
              v-if="display"
              v-model="fiche.secteur"
              placeholder="Secteur du bien"
              class="d-inline-block mb-2 mb-lg-0"
              id="secteur"
              name="secteur">
              <el-option
                v-for="(item, idx) in secteurOptions"
                :key="idx"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <b-form-invalid-feedback :state="error.secteur">{{ errorMessage }}
            </b-form-invalid-feedback>
          </div>
        </div>
        <div class="col-6 col-sm-4 col-md-3 p-2 p-lg-3">
          <div class="champs h-100">
            <label for="Localisation"
                   class="text-secondary required">Lieu</label>
            <AutoCompleteGouvApi @changedGPSData="changeGPSData"></AutoCompleteGouvApi>
            <b-form-invalid-feedback :state="error.lieu">{{ errorMessage }}
            </b-form-invalid-feedback>
          </div>
        </div>
        <div class="col-6 col-sm-4 col-md-3 p-2 p-lg-3">
          <div class="champs h-100">
            <b-form-group id="surfaceGroup"
                          class="d-flex flex-column justify-content-between h-100 m-0"
                          label="Surface m"
                          label-for="surface"
                          label-class="requiredSurface text-secondary"
                          :invalid-feedback="errorMessage"
                          :state="error.surface">
              <b-form-input min="0"
                            type="number"
                            placeholder="Surface"
                            id="surface"
                            name="surface"
                            v-model="fiche.surface"
                            :state="error.surface"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="col-6 col-sm-4 col-md-3 p-2 p-lg-3">
          <div class="champs h-100">
            <b-form-group id="surfaceHabitableGroup"
                          class="d-flex flex-column justify-content-between h-100 m-0"
                          label="Surface habitable m"
                          label-for="surfaceHabitable"
                          label-class="requiredSurface text-secondary"
                          :invalid-feedback="errorMessage"
                          :state="error.surfaceHabitable">
              <b-form-input min="0"
                            type="number"
                            placeholder="Surface habitable"
                            id="surfaceHabitable"
                            name="surfaceHabitable"
                            v-model="fiche.surfaceHabitable"
                            :state="error.surfaceHabitable"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="col-6 col-sm-4 col-md-3 p-2 p-lg-3">
          <div class="champs h-100">
            <b-form-group id="terrainGroup"
                          class="d-flex flex-column justify-content-between h-100 m-0"
                          label="Terrain m"
                          label-for="surfaceTerrain"
                          label-class="requiredSurface text-secondary"
                          :invalid-feedback="errorMessage"
                          :state="error.surfaceTerrain">
              <b-form-input min="0"
                            type="number"
                            placeholder="Surface du terrain"
                            id="surfaceTerrain"
                            name="surfaceTerrain"
                            v-model="fiche.surfaceTerrain"
                            :state="error.surfaceTerrain"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="col-6 col-sm-4 col-md-3 p-2 p-lg-3">
          <div class="champs h-100">
            <b-form-group id="prixGroup"
                          class="d-flex flex-column justify-content-between h-100 m-0"
                          label="Prix en euros"
                          label-for="prix"
                          label-class="required text-secondary"
                          :invalid-feedback="errorMessage"
                          :state="error.prix">
              <b-form-input min="0"
                            type="number"
                            placeholder="Prix souhaité"
                            id="prix"
                            name="prix"
                            v-model="fiche.prix"
                            :state="error.prix"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="col-12 col-md-6 p-2 p-lg-3">
          <div class="champs h-100">
            <b-form-group id="description"
                          class="d-flex flex-column justify-content-between h-100 m-0"
                          label="Description de votre bien"
                          label-for="description"
                          label-class="required text-secondary"
                          :invalid-feedback="errorMessage"
                          :state="error.description">
              <b-form-textarea id="description"
                               name="description"
                               v-model="fiche.description"
                               placeholder="Description de votre bien en quelques lignes"
                               rows="6"
                               max-rows="10"
                               :state="error.description"></b-form-textarea>
            </b-form-group>
          </div>
        </div>
        <div class="col-12 col-md-6 p-2 p-lg-3 d-flex flex-column">
          <b-form-checkbox id="conditionsRgpd"
                           v-model="fiche.rgpd"
                           name="conditionsRgpd"
                           class="pl-4 pr-0 py-0"
                           value="1"
                           unchecked-value="0">{{ focus.paragraphe3 ? focus.paragraphe3.texte : '' }}
                           <strong>* Champs obligatoires</strong>
          </b-form-checkbox>
          <b-form-invalid-feedback :state="error.rgpd">{{ errorMessage }}
          </b-form-invalid-feedback>
          <b-button type="submit"
                    variant="secondary"
                    class="bold ml-auto mt-auto small-ls text-uppercase py-1 px-5"
                    squared>Envoyer</b-button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import DataApi from 'fm-data-api'
import { FormGroupPlugin, FormPlugin, FormInputPlugin, FormTextareaPlugin, FormCheckboxPlugin, InputGroupPlugin, ButtonPlugin } from 'bootstrap-vue'
import lozad from 'lozad'
import { getFocus } from '../../mixins/getFocus'

Vue.use(FormGroupPlugin)
Vue.use(FormPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(InputGroupPlugin)
Vue.use(ButtonPlugin)

const observer = lozad() // lazy loads elements with default selector as '.lozad'
observer.observe()

export default {
  name: 'Achat',
  mixins: [getFocus],
  components: {
    ColorPointsHeader: () => import('../../components/ColorPointsHeader'),
    AutoCompleteGouvApi: () => import('../../components/AutoCompleteGouvApi')
  },
  data () {
    return {
      display: false,
      pinkHeaderMessage: {
        titre: '',
        sousTitre: ''
      },
      cgvText: '',
      paragraphe1: '',
      srcGraphique: require('../../assets/images/graphique-page-vente@2x.jpg'),
      civilitesOptions: [
        {
          id: 1,
          label: 'Madame',
          value: 'Madame'
        },
        {
          id: 2,
          label: 'Monsieur',
          value: 'Monsieur'
        }
      ],
      typeBienOptions: [
        { id: 1, value: 'Maison / Villa', label: 'Maison / Villa' },
        { id: 2, value: 'Appartement', label: 'Appartement' },
        { id: 3, value: 'Terrain', label: 'Terrain' },
        { id: 4, value: 'Commerce', label: 'Commerce' },
        { id: 5, value: 'Bureau / Local commercial', label: 'Bureau / Local commercial' },
        { id: 6, value: 'Parking', label: 'Parking' },
        { id: 7, value: 'Immeuble', label: 'Immeuble' },
        { id: 8, value: 'Hangar', label: 'Hangar' },
        { id: 9, value: 'Hôtel particulier', label: 'Hôtel particulier' },
        { id: 10, value: 'Droit au bail', label: 'Droit au bail' },
        { id: 11, value: 'Divers', label: 'Divers' }
      ],
      secteurOptions: [
        { id: 1, label: 'Centre-ville', value: 'Centre-ville' },
        { id: 2, label: 'Périphérie', value: 'Péripherie' }
      ],
      fiche: {
        civilite: 'Madame',
        nom: null,
        prenom: null,
        email: null,
        telephone: '',
        type: 'Maison / Villa',
        secteur: 'Centre-ville',
        lieu: null,
        surface: null,
        surfaceHabitable: null,
        surfaceTerrain: null,
        prix: null,
        description: null,
        rgpd: null
      },
      error: {
        nom: null,
        prenom: null,
        type: null,
        secteur: null,
        lieu: null,
        surface: null,
        surfaceHabitable: null,
        surfaceTerrain: null,
        prix: null,
        description: null,
        rgpd: null,
        email: null
      },
      formSent: false,
      /* message d'erreur affiché pour un champs requis vide */
      errorMessage: 'Ce champs est requis',
      focus: {}
    }
  },
  methods: {
    changeGPSData (centre) {
      this.fiche.lieu = centre.commune
    },
    checkErrors () {
      this.error.civilite = (!!this.fiche.civilite)
      this.error.type = (!!this.fiche.type)
      this.error.nom = (!!this.fiche.nom)
      this.error.prenom = (!!this.fiche.prenom)
      this.error.secteur = (!!this.fiche.secteur)
      this.error.email = (!!this.fiche.email)
      this.error.lieu = (!!this.fiche.lieu)
      this.error.surface = (!!this.fiche.surface)
      this.error.surfaceHabitable = (!!this.fiche.surfaceHabitable)
      this.error.surfaceTerrain = (!!this.fiche.surfaceTerrain)
      this.error.prix = (!!this.fiche.prix)
      this.error.description = (!!this.fiche.description)
      this.error.rgpd = (!!this.fiche.rgpd && this.fiche.rgpd !== '0')
      let stop = false
      Object.entries(this.error).forEach(([key, value]) => {
        if (value === false) {
          console.log('error : ' + key)
          stop = true
        }
      })
      if (stop) {
        setTimeout(() => {
          Object.keys(this.error).forEach((key) => {
            this.error[key] = null
          })
        }, 3000)
      } else {
        this.addFiche()
      }
    },
    async addFiche () {
      const bienToSend = this.fiche
      const options = {
        apiUrl: this.$apiUrl,
        databaseName: this.$databaseName,
        token: await this.$getMainToken()
      }
      this.dataApi = new DataApi(options)
      this.dataApi.createRecord('W_BienAEvaluer', bienToSend)
        .then((response) => {
          console.log(response)
          this.formSent = true
        })
    },
    myEventHandler () {
      if (window.innerWidth < 767) {
        this.srcGraphique = require('../../assets/images/graphique-page-vente.jpg')
      } else {
        this.srcGraphique = require('../../assets/images/graphique-page-vente@2x.jpg')
      }
      observer.observe()
    }
  },
  created () {
    if (window.innerWidth < 767) {
      this.srcGraphique = require('../../assets/images/graphique-page-vente.jpg')
    }
    window.addEventListener('resize', this.myEventHandler)
  },
  mounted () {
    const observer = lozad()
    observer.observe()
    this.display = true
  },
  async beforeMount () {
    await this.getFocus('Tolus Immo', 'Vente')
      .then(res => {
        this.focus = res
          this.pinkHeaderMessage.titre = this.focus.cartouche ? this.focus.cartouche.titre : ''
          this.pinkHeaderMessage.sousTitre = this.focus.cartouche ? this.focus.cartouche.texte : ''
      })
  }
}
</script>
<style lang="scss" scoped>

  // Load Bootstrap custom variables
  @import '../../assets/styles/custom.scss';

  input::placeholder {
    color: #68686880 !important ;
    font-size: 1rem !important ;
  }
  .form-control {
    border: none !important ;
  }

  .champs {
    border: 1px solid $grey !important;
    padding: 1rem !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: space-between !important;
  }

  ::v-deep .required::after {
    content:" *";
    font-size: 80%;
    vertical-align: super;
  }

  ::v-deep .requiredSurface::after {
    content:"2 *";
    font-size: 80%;
    vertical-align: super;
  }

  ::v-deep .el-input__inner,
  ::v-deep input {
    border: none !important;
    color: var(--secondary) !important;
  }

  .el-select-dropdown__item.selected {
    color: var(--secondary);
    font-weight: 700;
  }
  .autoCompleteInput input, .autoCompleteInput .input-group {
    height: 100% !important;
    border-radius: 0;
  }
  ::v-deep ::placeholder {
    color: #C0C4CC !important;
    font-size: 1rem !important;
  }
  ::v-deep .autoCompleteInput .form-control {
    border: none !important;
    font-size: 1rem !important;
    input.form-control {
      color: var(--secondary) !important;
    }
  }
</style>
